// @ts-check

import { get, getAll } from "../utilities/querySelector";

const footer = get( '.site-footer' );
const openers = getAll( '[data-form-open]' );
const closer = get( '[data-form-close]', footer );
const main = get( '[data-footer-main]', footer );
const form = get( '[data-footer-form]', footer );

openers.forEach( opener => opener.addEventListener( 'click', openForm ) );
closer.addEventListener( 'click', closeForm );

hide( form );

function openForm() {
    const anim = fadeOut( main );
    anim.addEventListener( 'finish', () => {
        fadeIn( form );
    } );
}

function closeForm() {
    const anim = fadeOut( form );
    anim.addEventListener( 'finish', () => {
        fadeIn( main );
    } );
}

function fadeOut( element ) {
    const anim = element.animate( {
        opacity: [1, 0]
    }, { duration: 600, easing: 'ease' } );

    anim.addEventListener( 'finish', () => {
        element.style.setProperty( 'display', 'none' );
    } );

    return anim;
}

function fadeIn( element ) {
    element.style.removeProperty( 'display' );
    const anim = element.animate( {
        opacity: [0, 1]
    }, { duration: 600, easing: 'ease' } );

    return anim;
}

function hide( element ) {
    element.style.setProperty( 'display', 'none' );
}